import CustomersIndex from "../../pages/dashboard/customers";
import BusinessCustomersIndex from "../../pages/dashboard/customers/BusinessCustomerPage";
import CustomerSingle from "../../pages/dashboard/customers/CustomerSingle";
import DeleteCustomerIndex from "../../pages/dashboard/customers/DeleteCustomerPage";
import WebCustomersIndex from "../../pages/dashboard/customers/WebCustomerPages";
import { ALL_ROUTES } from "../AllRoutes";

export const customer_route_group = [
  {
    path: ALL_ROUTES?.DASHBOARD_CUSTOMER,
    element: CustomersIndex,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_CUSTOMER_BUSINESS,
    element: BusinessCustomersIndex,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_CUSTOMER_WEB,
    element: WebCustomersIndex,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_CUSTOMER_SINGLE,
    element: CustomerSingle,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_DELETED_CUSTOMERS,
    element: DeleteCustomerIndex,
  },
];
